export default "__VITE_ASSET__DHby0Kch__"